import script from "./quicklinkComposer.vue?vue&type=script&lang=js"
export * from "./quicklinkComposer.vue?vue&type=script&lang=js"

import "./quicklinkComposer.vue?vue&type=style&index=0&id=880e902a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-880e902a"]])

export default __exports__